import script from "./ScopedSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopedSlot.vue?vue&type=script&setup=true&lang=js"

import "./ScopedSlot.vue?vue&type=style&index=0&id=78762284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78762284"]])

export default __exports__